import type { ComponentProps } from "react"
import type { IssuePriority } from "~/lib/enums"
import { enumFormat } from "~/lib/utils"
import { IssuePropertyIcon } from "./IssuePropertyIcon"

export const priorityConfigs = {
	None: { level: 0, color: "light-dark(#64748b, #a3adbd)" },
	Low: { level: 1, color: "light-dark(#047857, #6acba2)" },
	Medium: { level: 2, color: "light-dark(#a16207, #e8bd62)" },
	High: { level: 3, color: "light-dark(#c2410c, #f0a16b)" },
	Urgent: { level: 4, color: "light-dark(#be123c, #f07d96)" }
} satisfies Record<IssuePriority, { level: number; color: string }>

export function PriorityIcon({
	priority,
	...props
}: Omit<ComponentProps<"svg">, "color"> & {
	priority: IssuePriority
	withText?: boolean
}) {
	const config = priorityConfigs[priority]
	return (
		<IssuePropertyIcon
			label={enumFormat(priority)}
			color={config.color}
			{...props}
		>
			{priority === "None" ? (
				<path d="M4 8h8" />
			) : priority === "Urgent" ? (
				<>
					<rect
						x="2"
						y="2"
						width="12"
						height="12"
						rx="3"
						fill="currentColor"
						fillOpacity="0.12"
					/>
					<path d="M8 5v3.5" strokeWidth="1.75" />
					<circle cx="8" cy="11" r="0.9" fill="currentColor" stroke="none" />
				</>
			) : (
				[5, 8, 11].map((height, index) => (
					<rect
						key={height}
						x={2 + index * 4.5}
						y={13.5 - height}
						width="3"
						height={height}
						rx="0.8"
						fill="currentColor"
						stroke="none"
						opacity={index < config.level ? 1 : 0.18}
					/>
				))
			)}
		</IssuePropertyIcon>
	)
}
